import { shuffleArray } from 'utils/transforms';
import { PlanType } from 'models/Plan';

type SurveyOption = {
  id: string;
  label: string;
  planType?: PlanType;
};

class SkipSurvey {
  static options = [
    {
      id: 'save_money',
      label: 'I need to save money',
    },
    {
      id: 'busy_to_cook',
      label: 'I am too busy to cook',
      planType: PlanType.MEAL_KIT,
    },
    {
      id: 'no_premade_needed',
      label: 'I do not need pre-made meals',
      planType: PlanType.PREPARED,
    },
    {
      id: 'planning_on_cancelling',
      label: 'I’m planning on cancelling in the future',
    },
    {
      id: 'traveling',
      label: 'I am traveling',
    },
    {
      id: 'remaining_meals',
      label: 'I have remaining meals to cook from previous weeks',
    },
    {
      id: 'dislike_meals',
      label: 'I did not like the meals',
    },
  ];

  /**
   * Returns shuffled SurveyOptions with the 'other' option appended at
   * the end. Filters out options that are not meant for the PlanType
   * passed as parameter. Assumes that options that don't specify a
   * PlanType are valid for both.
   */
  static getOptions(planType?: PlanType): SurveyOption[] {
    const filteredOptions = this.options.filter((option) => (
      option.planType === undefined || option.planType === planType
    ));

    return shuffleArray(filteredOptions)
      .concat([{ id: 'other', label: 'Other' }]);
  }

  // Skip Survey Options for D26 Skip Survey
  static getOptionsV2(): SurveyOption[] {
    return [
      ...this.options.filter(
        (option) => option.planType !== PlanType.PREPARED,
      ),
      {
        id: 'other',
        label: 'Other',
      },
    ];
  }
}

export default SkipSurvey;
